import { Mark, mergeAttributes } from '@tiptap/core';
import Variantizers from "../../../../variantizer/Variantizers.js";
import S from './LevTextMark.css';
const LevTextMark = Mark.create({
  name: 'levText',
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  addAttributes() {
    return {
      variant: {
        default: null,
        parseHTML: element => element.getAttribute('data-variant'),
        renderHTML: attributes => {
          return {
            'data-variant': attributes.variant
          };
        }
      }
    };
  },
  parseHTML() {
    return [{
      tag: 'span',
      getAttrs: node => {
        return node.hasAttribute('data-variant') ? node.getAttribute('data-variant') : null;
      }
    }];
  },
  renderHTML({
    HTMLAttributes
  }) {
    const {
      'data-variant': dataVariant
    } = HTMLAttributes;
    let attrs = {
      class: S.text
    };
    const {
      editor
    } = this;
    if (!this.editor?.options?.editable) {
      let val;
      try {
        val = dataVariant ? JSON.parse(dataVariant) : null;
      } catch (err) {}
      if (val) {
        const variant = Variantizers.getVariant(val, editor?.options?.editorProps?.object, editor?.options?.editorProps?.context);
        if (variant) {
          const theme = editor?.options?.editorProps?.theme;
          const classes = theme?.classes('Text', 'text', variant);
          attrs = {
            class: classes
          };
        } else {
          attrs = {};
        }
      }
    }
    return ['span', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, attrs), 0];
  },
  addCommands() {
    return {
      setVariant: variant => ({
        commands
      }) => {
        let dataValue;
        try {
          dataValue = JSON.stringify(variant);
        } catch (err) {}
        return commands.setMark(this.name, {
          variant: dataValue
        });
      },
      unsetVariant: () => ({
        commands
      }) => {
        return commands.unsetMark(this.name);
      }
    };
  }
});
export default {
  id: 'Rich.Text.Editor.Extension.LevTextMark',
  extension: LevTextMark
};